import { FC } from "react";
import {
  Arrest2Icon,
  ArrowUpDashIcon,
  CommunityIcon,
  DocumentIcon,
  DoorLeftIcon,
  DoorRightIcon,
  DriverIdIcon,
  EyeIcon,
  HandIcon,
  HoodIcon,
  House2Icon,
  House3Icon,
  HouseIcon,
  IdCardIcon,
  KeyIcon,
  LicenseIcon,
  LipsIcon,
  MaskIcon,
  MedicalCardIcon,
  MilitaryIdIcon,
  OpenGlassIcon,
  PersonIcon,
  PoliceIcon,
  RepeatIcon,
  Safe2Icon,
  Shield2Icon,
  ShieldIcon,
  Smile2Icon,
  TreatmentIcon,
  Trunk2Icon,
  Vehicle2Icon,
  Vehicle4Icon,
  VehicleIcon,
} from "@/shared/icons";
import { BaseIconProps } from "@/shared/icons/BaseIcon";

const iconDict: Record<string, FC<BaseIconProps>> = {
  "vehicle.manage.title": VehicleIcon,

  "vehicle.manage.trunk.title": Trunk2Icon,
  "vehicle.manage.trunk.toggle": ArrowUpDashIcon,
  "vehicle.manage.trunk.inventory": EyeIcon,

  "vehicle.manage.gloveBox.title": OpenGlassIcon,
  "vehicle.manage.gloveBox.toggle": ArrowUpDashIcon,
  "vehicle.manage.gloveBox.inventory": EyeIcon,

  "vehicle.manage.doors.title": DoorLeftIcon,
  "vehicle.manage.doors.frontLeft": DoorLeftIcon,
  "vehicle.manage.doors.frontRight": DoorRightIcon,
  "vehicle.manage.doors.backLeft": DoorLeftIcon,
  "vehicle.manage.doors.backRight": DoorRightIcon,

  "vehicle.manage.toggleLock": KeyIcon,
  "vehicle.manage.toggleWindows": DoorLeftIcon,
  "vehicle.manage.toggleHood": HoodIcon,

  // EntityType: Player

  "player.faction.title": ShieldIcon,

  "player.acquaintance.title": Smile2Icon,
  "player.acquaintance.greet": HandIcon,
  "player.acquaintance.kiss": LipsIcon,

  "player.estate.title": HouseIcon,
  "player.estate.trade": RepeatIcon,
  "player.estate.sellEstate": House2Icon,
  "player.estate.sellVehicle": Vehicle2Icon,
  "player.estate.inviteTenant": House3Icon,
  "player.estate.inviteEmployee": PersonIcon,
  "player.estate.sellBusiness": Safe2Icon,

  "player.documents.title": DocumentIcon,
  "player.documents.admin_employee": CommunityIcon,
  "player.documents.hospital_employee": TreatmentIcon,
  "player.documents.criminal_record_certificate": Arrest2Icon,
  "player.documents.driver_license": DriverIdIcon,
  "player.documents.fsb_employee": Shield2Icon,
  "player.documents.traffic_police_employee": Vehicle4Icon,
  "player.documents.medical_card": MedicalCardIcon,
  "player.documents.military_id": MilitaryIdIcon,
  "player.documents.defense_ministry_employee": DocumentIcon,
  "player.documents.police_employee": PoliceIcon,
  "player.documents.psychiatric_certificate": MaskIcon,
  "player.documents.vehicle_registration_certificate": DocumentIcon,
  "player.documents.weapon_license": LicenseIcon,
  "player.documents.passport": IdCardIcon,
};

export default iconDict;
